import { motion } from "framer-motion";
import { useTranslation } from "../hooks/useTranslation";

export default function Contact() {
  const { t } = useTranslation();
  
  const contactMethods = [
    {
      id: "email",
      icon: "📧",
      title: t('contact.methods.email.title'),
      value: "bargeanjali650@gmail.com",
      link: "mailto:bargeanjali650@gmail.com",
      description: t('contact.methods.email.desc'),
      color: "from-red-500/10 to-pink-500/10"
    },
    {
      id: "linkedin",
      icon: "💼",
      title: t('contact.methods.linkedin.title'),
      value: "linkedin.com/in/anjali-barge",
      link: "https://linkedin.com/in/anjali-barge",
      description: t('contact.methods.linkedin.desc'),
      color: "from-blue-500/10 to-cyan-500/10"
    },
    {
      id: "github",
      icon: "👩‍💻",
      title: t('contact.methods.github.title'),
      value: "github.com/AB2511",
      link: "https://github.com/AB2511",
      description: t('contact.methods.github.desc'),
      color: "from-purple-500/10 to-indigo-500/10"
    },
    {
      id: "orcid",
      icon: "🔬",
      title: t('contact.methods.orcid.title'),
      value: "0009-0005-1983-9214",
      link: "https://orcid.org/0009-0005-1983-9214",
      description: t('contact.methods.orcid.desc'),
      color: "from-green-500/10 to-emerald-500/10"
    }
  ];

  const opportunities = [
    { icon: "🚀", text: t('contact.interests.items')[0] },
    { icon: "🧠", text: t('contact.interests.items')[1] },
    { icon: "🔬", text: t('contact.interests.items')[2] },
    { icon: "💡", text: t('contact.interests.items')[3] },
    { icon: "🌍", text: t('contact.interests.items')[4] },
    { icon: "📚", text: t('contact.interests.items')[5] }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-secondary to-primary">
      <div className="section-padding">
        <div className="container-width">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              {t('contact.title')}
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-accent to-accent-light mx-auto mb-8"></div>
            <p className="text-xl text-muted-light max-w-2xl mx-auto mb-4">
              {t('contact.subtitle')}
            </p>
            <p className="text-sm text-muted max-w-2xl mx-auto">
              {t('contact.description')}
            </p>
          </motion.div>

          {/* Contact Methods */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16"
          >
            {contactMethods.map((method, index) => (
              <motion.a
                key={method.id}
                href={method.link}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1 * index, duration: 0.6 }}
                className={`card card-hover bg-gradient-to-br ${method.color} block group`}
              >
                <div className="flex items-start space-x-4">
                  <motion.div
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    className="text-4xl"
                  >
                    {method.icon}
                  </motion.div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-accent group-hover:text-accent-light transition-colors mb-2">
                      {method.title}
                    </h3>
                    <p className="text-sm text-muted mb-3">{method.description}</p>
                    <p className="text-accent/80 font-mono text-sm break-all">{method.value}</p>
                  </div>
                </div>
              </motion.a>
            ))}
          </motion.div>

          {/* Interests Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mb-16"
          >
            <h2 className="text-3xl font-bold text-accent mb-8 text-center">{t('contact.interests.title')}</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
              {opportunities.map((opportunity, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.1 * index, duration: 0.5 }}
                  className="card bg-tertiary/20 hover:bg-tertiary/30 transition-all duration-300 text-center"
                >
                  <div className="text-2xl mb-2">{opportunity.icon}</div>
                  <p className="text-sm text-muted-light">{opportunity.text}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* CTA Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-center mb-16"
          >
            <div className="card bg-gradient-to-r from-accent/10 to-accent-light/10 max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-accent mb-4">{t('contact.cta.title')}</h3>
              <p className="text-lg text-muted-light mb-6">
                {t('contact.cta.description')}
              </p>
              
              <motion.a
                href="mailto:bargeanjali650@gmail.com?subject=Collaboration Opportunity&body=Hi Anjali, I'd like to discuss..."
                className="btn-primary inline-flex items-center gap-2"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {t('contact.cta.button')}
              </motion.a>
            </div>
          </motion.div>


        </div>
      </div>
    </div>
  );
}